<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      isRouterAlive: true,
    }
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  created(){
    console.log(
      "%c 好好学习 天天向上 \n==================",
      " text-shadow: 0 1px 0 #ccc,0 2px 0 #c9c9c9,0 2px 0 #bbb,0 2px 0 #b9b9b9,0 2px 0 #aaa,0 2px 1px rgba(0,0,0,.1),0 0 2px rgba(0,0,0,.1),0 1px 2px rgba(0,0,0,.3),0 2px 2px rgba(0,0,0,.2),0 2px 2px rgba(0,0,0,.5),0 2px 2px rgba(0,0,0,.2),0 2px 2px rgba(0,0,0,.3);font-size:2em;color:#4589e9"
    );
  },
  mounted(){
    document.oncontextmenu = function(){
      return false;
    };

    window.addEventListener('message', (data) => {
      if(data.data.isExit){
        this.$logOut()
      }
    },false);

    function checkIE(){
      return '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style
    }
    if (checkIE()) {
      window.addEventListener('hashchange', () => {
        var currentPath = window.location.hash.slice(1);
        if (this.$route.path !== currentPath) {
          this.$router.push(currentPath)
        }
      }, false)
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function() {
        this.isRouterAlive = true
      })
    }
  },
};
</script>
<style>
@import "../static/fonts/iconfont.css";
#app {
  height: 100%;
  overflow:hidden;
}

.editorShowArea pre code {
  background-color: #292A2B;
  border: 0;
  display: inline;
  line-height: inherit;
  margin: 0;
  overflow: auto;
  padding: 10px;
  word-wrap: normal;
}

.editorShowArea {
  padding: 10px;
  word-break: break-all;
  white-space: pre-wrap;
  line-height: 1.2;
}

.editorShowArea div {
  word-break: break-all;
  white-space: pre-wrap;
}
.editorShowArea img {
  max-width: 100%;
}
.editorShowArea p{
  white-space: pre-wrap;
  word-wrap: break-word;
}
.editorShowArea table {
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;
}
.editorShowArea table td,
.editorShowArea table th {
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
  padding: 3px 5px;
}
.editorShowArea table th {
  background: #f1f1f1;
}

/* blockquote 样式 */
.editorShowArea blockquote {
  display: block;
  border-left: 8px solid #d0e5f2;
  padding: 5px 10px;
  margin: 10px 0;
  line-height: 1.4;
  font-size: 100%;
  background-color: #f1f1f1;
}

/* code 样式 */
.editorShowArea code {
  display: inline-block;
  *display: inline;
  *zoom: 1;
  background-color: #f1f1f1;
  border-radius: 3px;
  padding: 3px 5px;
  margin: 0 3px;
}
.editorShowArea pre code {
  display: block;
}

/* ul ol 样式 */
.editorShowArea ul,
.editorShowArea ol {
  margin: 10px 0 10px 20px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue